import { createContext, useContext } from "react";

export const TreeSelectContext = createContext(undefined);

export const useTreeSelect = () => {
  const context = useContext(TreeSelectContext);

  if (!context) {
    throw new Error();
  }

  return context;
};
